import AppStoreContext from 'contexts/AppStoreContext';
import { List, Set } from 'immutable';
import * as React from 'react';
import { SheetVersion } from 'records/SheetVersion';

export type SheetManagerValue = {
  getSheetVersions: (pageids: Set<string>) => List<SheetVersion>;
};

const SheetManagerContext = React.createContext<SheetManagerValue | null>(null);

export const SheetManagerProvider = SheetManagerContext.Provider;

export const AppSheetManagerProvider: React.FC = ({ children }) => {
  const { state: appState } = React.useContext(AppStoreContext);

  const sheetManager: SheetManagerValue = {
    getSheetVersions: (pageids) =>
      appState.sheets
        .valueSeq()
        .flatMap((sheet) => sheet.versions)
        .filter((sheetVersion) => pageids.has(sheetVersion.pageid))
        .toList(),
  };

  return (
    <SheetManagerProvider value={sheetManager}>{children}</SheetManagerProvider>
  );
};

export const useSheetManager = (): SheetManagerValue => {
  const sheetManager = React.useContext(SheetManagerContext);

  if (sheetManager === null) {
    throw new Error(
      'useSheetManager must be used within a SheetManagerProvider'
    );
  }

  return sheetManager;
};
